import type { Route } from "./+types/course-slug";
import Page from "../pages/CourseSlugPage";
import { pageMeta } from "../lib/meta";
import { courseSchema, breadcrumbSchema, SITE_URL } from "../components/content/SEO/SEO";
import { content, type CourseDetail } from "../lib/content";

export async function loader({ params }: Route.LoaderArgs): Promise<{ course: CourseDetail | null }> {
  try {
    const course = await content.course(params.slug);
    return { course };
  } catch {
    return { course: null };
  }
}
export function meta({ data, params }: Route.MetaArgs) {
  const course = data?.course;
  const title = course?.title ?? "Course";
  const description = course?.shortDescription ?? "A system design / engineering course by Gazar.";
  const image = (course?.image as any)?.url;
  const jsonLd = course
    ? [
        courseSchema({
          title,
          description,
          slug: params.slug,
          image,
          price: course.price,
          level: course.level,
        }),
        breadcrumbSchema([
          { name: "Home", url: SITE_URL },
          { name: "Courses", url: `${SITE_URL}/courses` },
          { name: title, url: `${SITE_URL}/courses/${params.slug}` },
        ]),
      ]
    : undefined;
  return pageMeta({ title: `${title} | Gazar`, description, path: `/courses/${params.slug}`, image, jsonLd });
}
export default function R({ loaderData }: Route.ComponentProps) { return <Page course={loaderData.course} />; }
